module.exports = __webpack_public_path__ + "img/BlueOutline300.8bb24f5e.png";